import { FormatStringByWordLength, DoArraysOverlap, Split, Join } from "../../../shared/scripts/array-functions";

export class ContactListingDto {
    Id: number;
    ContactName: string;
    SiteNames: string[];
    StudySiteNames: string[];
    StudyNames: string[];
    Role: string[];
    StudyNameAndRole: string[];
    Email: string;
    PhoneNumber: string;
    Notes: string;
    FirstName: string;
    LastName: string;
    Prefix: string;
    Title: string;

    constructor() { }

    initialize(): void {
        this.SiteNames = this.SiteNames.concat(this.StudySiteNames);
    }

    matchesFilter(site: any, role: any, study: any): boolean {
        // Site filter
        let values: string[] = [];
        if (this.SiteNames.length > 0) { values.push(...this.SiteNames); }
        else { values.push("Unassigned"); }
        if (!DoArraysOverlap(site, values)) { return false; }
        // Role filter
        //let roleValue: string = "Unassigned";
        //if (this.Role && this.Role.length > 0) { roleValue = this.Role; }
        //else {
        //    var test = 1;
        //}
        //if (role && role.length > 0 && !role.includes(roleValue)) return false;
        values = [];
        if (this.Role.length > 0) { values.push(...this.Role); }
        else { values.push("Unassigned"); }
        if (!DoArraysOverlap(role, values)) { return false; }

        // Study filter
        let studyValues: string[] = [];
        if (this.StudyNames.length > 0) { studyValues.push(...this.StudyNames); }
        else { studyValues.push("Unassigned"); }
        if (!DoArraysOverlap(study, studyValues)) { return false; }

        return true;
    }
}

export class JobFunctionEntity {
    Id: number;
    Name: string;
}

export class ContactListingFormObject {
    Id: number;
    Email: string;
    PhoneNumber: string;
    Notes: string;
    FirstName: string;
    LastName: string;
    Prefix: string;
    Title: string;
    Sites: ContactFormSiteObject[];
    initialize(): void {
    }
}

export class ContactFormSiteObject {
    SiteId: number;
    StudyIds: number[];
    JobFunctionIds: (number | null)[];
    IsPrimaryContacts: boolean[];
    IsReceivingAllCommunications: boolean[];
}